import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enableRowSelection", "defaultSelectedRowIds", "selectedRowIds", "onRowSelectionChange"];
import { useCallback, useMemo, useState } from 'react';
import { CHECKBOX_CHECK_TYPE_DASH, CHECKBOX_CHECK_TYPE_TICK } from '../../Checkbox';
export var useDataTableRowSelection = function useDataTableRowSelection(dataSafe, _ref) {
  var enableRowSelection = _ref.enableRowSelection,
      defaultSelectedRowIds = _ref.defaultSelectedRowIds,
      selectedRowIds = _ref.selectedRowIds,
      onRowSelectionChange = _ref.onRowSelectionChange,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(defaultSelectedRowIds || []),
      _useState2 = _slicedToArray(_useState, 2),
      selectedRowIdsInternal = _useState2[0],
      setSelectedRowIdsInternal = _useState2[1];

  var selectedRowIdsActual = selectedRowIds || selectedRowIdsInternal;
  var onRowSelectionChangeInternal = useCallback(function (selection) {
    if (!selectedRowIds) {
      setSelectedRowIdsInternal(selection);
    }

    if (onRowSelectionChange) {
      onRowSelectionChange(selection);
    }
  }, [onRowSelectionChange, selectedRowIds]);

  var unselectRows = function unselectRows() {
    return onRowSelectionChangeInternal([]);
  };

  var rowIds = useMemo(function () {
    return dataSafe.map(function (item) {
      return item.id;
    });
  }, [dataSafe]);
  var allRowsSelected = !!selectedRowIdsActual && !!selectedRowIdsActual.length && !!rowIds && selectedRowIdsActual.length === rowIds.length;
  var someRowsSelected = !!selectedRowIdsActual && !!selectedRowIdsActual.length;
  var onHeadSelectorCellClick = useCallback(function () {
    if (!enableRowSelection) {
      return;
    }

    if (!someRowsSelected || someRowsSelected && !allRowsSelected) {
      onRowSelectionChangeInternal(rowIds ? _toConsumableArray(rowIds) : []);
    } else {
      onRowSelectionChangeInternal([]);
    }
  }, [rowIds, someRowsSelected, allRowsSelected, onRowSelectionChangeInternal, enableRowSelection]);
  var onDataSelectorCellClick = useCallback(function (event) {
    if (!enableRowSelection) {
      return;
    }

    var rowId = event.currentTarget.getAttribute('data-rowid');

    if (!rowId) {
      return;
    }

    var selected = selectedRowIdsActual.includes(rowId);
    onRowSelectionChangeInternal(selected ? selectedRowIdsActual.filter(function (id) {
      return id !== rowId;
    }) : [rowId].concat(_toConsumableArray(selectedRowIdsActual)));
  }, [selectedRowIdsActual, onRowSelectionChangeInternal, enableRowSelection]);
  return {
    result: {
      enableRowSelection: enableRowSelection,
      getSelectAllCheckboxCellProps: function getSelectAllCheckboxCellProps() {
        return {
          checked: someRowsSelected || allRowsSelected,
          checkedIcon: allRowsSelected ? CHECKBOX_CHECK_TYPE_TICK : CHECKBOX_CHECK_TYPE_DASH,
          isHeader: true,
          onClick: onHeadSelectorCellClick
        };
      },
      getSelectRowCheckboxCellProps: function getSelectRowCheckboxCellProps(rowId) {
        var isRowSelected = enableRowSelection && selectedRowIdsActual.includes(rowId);
        return {
          checked: isRowSelected,
          onClick: onDataSelectorCellClick,
          'data-rowid': rowId
        };
      },
      onDataSelectorCellClick: onDataSelectorCellClick
    },
    selectedRowIds: selectedRowIdsInternal,
    selectedRowIdsActual: selectedRowIdsActual,
    unselectRows: unselectRows,
    restProps: restProps
  };
};